import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Props from './FooterComponent';

export class Footer extends Component<Props> {
    getCopyrightText = () => {
        const date = new Date();
        let copyrightText = date.getFullYear() + ' ' + this.props.partner.copyright;
            if(this.props.partner.copyright_behalf) {
                copyrightText += ' on behalf of ' + this.props.partner.copyright_behalf;
            }

        return copyrightText;
    }

    render() {
        if (!this.props.partner) {
            return null;
        }

        return(
            <footer className="page__footer">
                <div className="page__footer__top">
                    <div className="page__footer__left">
                        <ul className="footer__links">
                            <li className="footer__link-item"><a href={this.props.partner.contact_url} target="_blank">Support</a></li>
                            <li className="footer__link-item"><a href={this.props.partner.tos_url} target="_blank">Terms of Service</a></li>
                            <li className="footer__link-item"><a href={this.props.partner.privacy_url} target="_blank">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div className="page__footer__right">
                        <div className="footer__branding">
                            <a href={this.props.partner.contact_url} className="footer__branding__image">
                                <span className="sr-only">{this.props.partner.name}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="page__footer__bottom">
                    <p className="copyright-text">&copy; {this.getCopyrightText()}</p>
                </div>
            </footer>
        )
    }
}

Footer.propTypes = {
    partner: PropTypes.object,
}

const mapStateToProps = (state, props) => {
    return {
        partner: state.partner,
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Footer);
